// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Filter_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21.619 4.643a1.48 1.48 0 0 0-1.369-.893H3.75a1.5 1.5 0 0 0-1.107 2.509l.007.008L9 13.047v7.203a1.5 1.5 0 0 0 2.332 1.249l3-2a1.5 1.5 0 0 0 .668-1.25v-5.202l6.35-6.78.008-.008a1.48 1.48 0 0 0 .26-1.616ZM3.75 5.25h0Zm9.954 6.992a.75.75 0 0 0-.204.508v5.5l-3 2v-7.5a.75.75 0 0 0-.202-.513L3.75 5.25h16.5Z',
  viewBox: '0 0 24 24',
  glyph: 'Filter_Stroke2_Corner0_Rounded',
})

export const FilterTimeline_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M18.75 12.75a.75.75 0 0 1-.75.75H6A.75.75 0 0 1 6 12h12a.75.75 0 0 1 .75.75Zm3-5.25H2.25a.75.75 0 0 0 0 1.5h19.5a.75.75 0 0 0 0-1.5Zm-7.5 9h-4.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5Z',
  viewBox: '0 0 24 24',
  glyph: 'FilterTimeline_Stroke2_Corner0_Rounded',
})
